(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-text-slider"] && !Shopify.designMode) return;
  try {
    
  class InlineVideoReels {
    constructor() {
      console.log('InlineVideoReels: Initializing...');
      this.reels = document.querySelectorAll('[data-video-reel]');
      this.previewTimeouts = new Map();
      console.log('InlineVideoReels: Found', this.reels.length, 'video reels');
      this.init();
    }

    init() {
      this.reels.forEach((reel, index) => {
        console.log(`InlineVideoReels: Initializing reel ${index}`);
        const playButton = reel.querySelector('.inline-video-reel__overlay button');
        const controlPlayPause = reel.querySelector('[data-control-play-pause]');
        const muteToggle = reel.querySelector('[data-mute-toggle]');
        const captionsToggle = reel.querySelector('[data-captions-toggle]');
        const video = reel.querySelector('.inline-video-reel__video');
        const previewVideo = reel.querySelector('.inline-video-reel__preview');

        console.log(`Reel ${index} elements:`, { playButton, video, previewVideo });

        // Play button click handler
        if (playButton) {
          playButton.addEventListener('click', (e) => {
            console.log('Play button clicked');
            e.preventDefault();
            e.stopPropagation();
            this.playVideo(reel);
          });
        }

        // Also add click handler to the entire overlay as fallback
        const overlay = reel.querySelector('.inline-video-reel__overlay');
        if (overlay) {
          overlay.addEventListener('click', (e) => {
            if (e.target === overlay || e.target.closest('button')) {
              e.preventDefault();
              e.stopPropagation();
              this.playVideo(reel);
            }
          });
        }

        if (controlPlayPause) {
          controlPlayPause.addEventListener('click', (e) => {
            e.stopPropagation();
            this.togglePlayPause(reel);
          });
        }

        if (muteToggle) {
          muteToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleMute(reel);
          });
        }

        if (captionsToggle) {
          captionsToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggleCaptions(reel);
          });
        } // Get video type for control logic
        const videoType = reel.getAttribute('data-video-type');

        // Add video event listeners for direct videos
        if (video && video.tagName === 'VIDEO') {
          video.addEventListener('loadeddata', () => {
            console.log('Video loaded:', video.src);
            video.setAttribute('data-video-ready', 'true');
          });

          video.addEventListener('error', (e) => {
            console.error('Video error:', e, video.src);
          });

          video.addEventListener('canplay', () => {
            console.log('Video can play:', video.src);
          });
        }

        // Hover preview functionality (only for direct videos)
        if (previewVideo && videoType === 'direct') {
          reel.addEventListener('mouseenter', () => this.startPreview(reel));
          reel.addEventListener('mouseleave', () => this.stopPreview(reel));
        }

        // Pause when clicking video area (but not on controls)
        if (video) {
          video.addEventListener('click', (e) => {
            const controls = reel.querySelector('.inline-video-reel__controls');
            if (!controls || !controls.contains(e.target)) {
              this.pauseVideo(reel);
            }
          });
        }
      });
    }
    playVideo(reel) {
      const video = reel.querySelector('.inline-video-reel__video');
      const videoType = reel.getAttribute('data-video-type');

      console.log('Playing video:', { videoType, video, reel });
      console.log('Video element details:', {
        tagName: video?.tagName,
        src: video?.src,
        readyState: video?.readyState,
        paused: video?.paused,
      });

      // Clear any existing preview
      this.stopPreview(reel);

      // Add playing class first
      reel.classList.add('inline-video-reel--playing');
      reel.setAttribute('data-playing', 'true');
      console.log('Added playing class to reel');
      if (videoType === 'youtube' || videoType === 'vimeo') {
        // Handle embedded videos
        const embedUrl = video.getAttribute('data-embed-url');
        console.log('Embedded video URL:', embedUrl);
        if (embedUrl) {
          // Set the src to trigger autoplay (only works on user interaction)
          video.src = embedUrl;
          console.log('Set iframe src to:', embedUrl);

          // Additional handling for YouTube autoplay
          if (videoType === 'youtube') {
            // Wait a moment for iframe to load, then try to trigger play via postMessage
            setTimeout(() => {
              try {
                video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
              } catch (error) {
                console.log('YouTube postMessage failed (expected in some cases):', error);
              }
            }, 1000);
          }
        }
      } else {
        // Handle direct videos
        if (video && video.tagName === 'VIDEO') {
          console.log('Playing direct video:', video.src);

          // Make video visible
          video.style.display = 'block';
          video.style.visibility = 'visible';

          const tryPlay = () => {
            console.log('Attempting to play video...');
            video.currentTime = 0;
            const playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise
                .then(() => {
                  console.log('Video started playing successfully');
                  console.log('Video state after play:', {
                    paused: video.paused,
                    currentTime: video.currentTime,
                    duration: video.duration,
                  });
                })
                .catch((error) => {
                  console.error('Error playing video:', error);

                  // If autoplay failed due to browser policy, show a message or handle it
                  if (error.name === 'NotAllowedError') {
                    console.log('Autoplay was prevented by browser policy');
                    // Show the built-in controls as fallback
                    video.controls = true;
                  } else {
                    // Try to load the video first
                    video.load();
                    setTimeout(() => {
                      video.play().catch((err) => {
                        console.error('Retry failed:', err);
                        video.controls = true; // Show controls as fallback
                      });
                    }, 100);
                  }
                });
            }
          };

          // Check if video is ready
          if (video.readyState >= 2) {
            console.log('Video ready, playing immediately');
            tryPlay();
          } else {
            console.log('Video not ready, waiting for canplay event');
            const onCanPlay = () => {
              console.log('Video can play event fired');
              video.removeEventListener('canplay', onCanPlay);
              tryPlay();
            };
            video.addEventListener('canplay', onCanPlay);
            console.log('Loading video...');
            video.load();
          }
        }
      }

      // Update play/pause button aria-label
      const playPauseBtn = reel.querySelector('[data-control-play-pause]');
      if (playPauseBtn) {
        playPauseBtn.setAttribute('aria-label', 'Pause video');
      }
    }

    pauseVideo(reel) {
      const video = reel.querySelector('.inline-video-reel__video');
      const videoType = reel.getAttribute('data-video-type');

      if (videoType === 'direct' && video && video.tagName === 'VIDEO') {
        video.pause();
      }

      reel.classList.remove('inline-video-reel--playing');
      reel.setAttribute('data-playing', 'false');

      // Update play/pause button aria-label
      const playPauseBtn = reel.querySelector('[data-control-play-pause]');
      if (playPauseBtn) {
        playPauseBtn.setAttribute('aria-label', 'Play video');
      }
    }

    togglePlayPause(reel) {
      const isPlaying = reel.classList.contains('inline-video-reel--playing');
      if (isPlaying) {
        this.pauseVideo(reel);
      } else {
        this.playVideo(reel);
      }
    }

    toggleMute(reel) {
      const video = reel.querySelector('.inline-video-reel__video');
      const muteBtn = reel.querySelector('[data-mute-toggle]');
      const videoType = reel.getAttribute('data-video-type');

      if (videoType === 'direct' && video && video.tagName === 'VIDEO') {
        video.muted = !video.muted;
        const isMuted = video.muted;

        muteBtn.setAttribute('data-muted', isMuted.toString());
        muteBtn.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');

        // Update icon based on mute state
        const icon = muteBtn.querySelector('svg path');
        if (icon) {
          if (isMuted) {
            icon.setAttribute(
              'd',
              'M792-56 671-177q-25 16-53 27.5T560-131v-82q14-5 27.5-10t25.5-12L480-368v208L280-360H120v-240h128L56-792l56-56 736 736-56 56Zm-8-232-58-58q17-31 25.5-65t8.5-70q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 53-14.5 102T792-288ZM650-422l-90-90v-130q47 22 73.5 66t26.5 96q0 15-2.5 29.5T650-422ZM480-592 376-696l104-104v208Zm-80 238v-94l-72-72H200v80h114l86 86Zm-36-130Z'
            );
          } else {
            icon.setAttribute(
              'd',
              'M560-131v-82q90-26 145-100t55-168q0-94-55-168T560-749v-82q124 28 202 125.5T840-481q0 127-78 224.5T560-131ZM120-360v-240h160l200-200v640L280-360H120Zm280-246-86 86H200v80h114l86 86v-252ZM300-480Z'
            );
          }
        }
      }
    }

    toggleCaptions(reel) {
      const ccOverlay = reel.querySelector('[data-cc-content]');
      const ccBtn = reel.querySelector('[data-captions-toggle]');

      if (ccOverlay && ccBtn) {
        const isEnabled = ccBtn.getAttribute('data-captions-enabled') === 'true';
        const newState = !isEnabled;

        ccBtn.setAttribute('data-captions-enabled', newState.toString());
        ccBtn.setAttribute('aria-label', newState ? 'Turn off captions' : 'Turn on captions');

        if (newState) {
          ccOverlay.classList.add('inline-video-reel__cc-overlay--visible');
        } else {
          ccOverlay.classList.remove('inline-video-reel__cc-overlay--visible');
        }

        // Update icon based on captions state
        const icon = ccBtn.querySelector('svg path');
        if (icon) {
          if (newState) {
            icon.setAttribute(
              'd',
              'M200-160q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h560q33 0 56.5 23.5T840-720v480q0 33-23.5 56.5T760-160H200Zm80-200h120q17 0 28.5-11.5T440-400v-40h-60v20h-80v-120h80v20h60v-40q0-17-11.5-28.5T400-600H280q-17 0-28.5 11.5T240-560v160q0 17 11.5 28.5T280-360Zm240 0h120q17 0 28.5-11.5T680-400v-40h-60v20h-80v-120h80v20h60v-40q0-17-11.5-28.5T640-600H520q-17 0-28.5 11.5T480-560v160q0 17 11.5 28.5T520-360Z'
            );
          } else {
            icon.setAttribute(
              'd',
              'm361-600 60 60H300v120h80v-20h60v40q0 17-11.5 28.5T400-360H280q-17 0-28.5-11.5T240-400v-160q0-17 11.5-28.5T280-600h81Zm-86-200h485q33 0 56.5 23.5T840-720v485l-80-80v-405H355l-80-80Zm445 360v40q0 9-3.5 17.5T706-369l-51-51h5v-20h60Zm-60-80v-20h-80v45l-60-60v-5q0-17 11.5-28.5T560-600h120q17 0 28.5 11.5T720-560v40h-60Zm-102 2Zm-154 74ZM168-793l73 73h-41v480h407L27-820l57-57L876-85l-57 57-132-132H200q-33 0-56.5-23.5T120-240v-480q0-25 13.5-44.5T168-793Z'
            );
          }
        }
      }
    }

    startPreview(reel) {
      const previewVideo = reel.querySelector('.inline-video-reel__preview');
      const videoType = reel.getAttribute('data-video-type');

      // Only show preview for direct videos and if not currently playing
      if (previewVideo && videoType === 'direct' && !reel.classList.contains('inline-video-reel--playing')) {
        // Clear any existing timeout
        if (this.previewTimeouts.has(reel)) {
          clearTimeout(this.previewTimeouts.get(reel));
        }

        reel.classList.add('inline-video-reel--previewing');

        // Reset and play preview
        previewVideo.currentTime = 0;
        previewVideo.play().catch((error) => {
          console.error('Error playing preview video:', error);
        });

        // Set 5-second timeout to stop preview
        const timeoutId = setTimeout(() => {
          this.stopPreview(reel);
        }, 5000);

        this.previewTimeouts.set(reel, timeoutId);
      }
    }

    stopPreview(reel) {
      const previewVideo = reel.querySelector('.inline-video-reel__preview');

      // Clear timeout
      if (this.previewTimeouts.has(reel)) {
        clearTimeout(this.previewTimeouts.get(reel));
        this.previewTimeouts.delete(reel);
      }

      reel.classList.remove('inline-video-reel--previewing');

      if (previewVideo) {
        previewVideo.pause();
        previewVideo.currentTime = 0;
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      console.log('DOM loaded, initializing InlineVideoReels');
      window.videoReelsInstance = new InlineVideoReels();
    });
  } else {
    console.log('DOM already loaded, initializing InlineVideoReels');
    window.videoReelsInstance = new InlineVideoReels();
  }

  } catch(e) { console.error(e); }
})();
})();
